<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <product-group />
        </b-col>
        <b-col
          cols="12"
        >
          <title-text />
        </b-col>

      </b-row>
    </b-card>
    <b-row>
      <b-col
        cols="12"
      >
        <image-card />
      </b-col>
    </b-row>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
/*
image
status
 */
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import ProductGroup from '@/views/Admin/Product_reynaers_cat/elements/ProductGroup.vue'
import TitleText from '@/views/Admin/Product_reynaers_cat/elements/TitleText.vue'
import ImageCard from '@/views/Admin/Product_reynaers_cat/elements/ImageCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    ProductGroup,
    TitleText,
    ImageCard,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
      imageUrl: this.$store.state.app.baseURL,
      snowOption: {
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['productReynaersCat/dataItem']
    },
  },
  created() {
    this.getProductGroups()
  },
  methods: {
    getProductGroups() {
      this.$store.dispatch('productReynaersCat/getDataList', {
        select: [
          'product_reynaers_cat.id AS id',
          'product_reynaers_cat.title AS title',
        ],
        where: {
          'product_reynaers_cat.id_product_reynaers_cat': null,
        },
      })
    },
  },
}
</script>
